import { MouseEventHandler } from 'react';
import cn from 'classnames';

function AuthSectionSwitch({
  goTo,
  subtitle,
  typeofSection,
  bottom = false,
  step,
}: {
  goTo: MouseEventHandler;
  subtitle?: { text: string; navigation?: { text: string; url: string } };
  typeofSection?: string;
  bottom?: boolean;
  step?: any;
}) {
  return (
    <div
      className={cn({
        authSubTextRowTop: typeofSection !== 'forgot' && !bottom,
        authSubTextRowTopOnly:
          (typeofSection === 'forgot' && !bottom) || step !== 1,
        authSubTextRowBottom:
          typeofSection !== 'forgot' && bottom && step === 1,
        hideAuthSubTextRowBottom:
          (typeofSection === 'forgot' && bottom) || (step !== 1 && bottom),
      })}
    >
      <p className="authPopupTextSmall">
        {subtitle?.text}
        <span
          className={cn('authSubtitleLink', {
            noURL: !subtitle?.navigation?.url,
          })}
          onClick={goTo}
        >
          {subtitle?.navigation?.text}
        </span>
      </p>
    </div>
  );
}

export default AuthSectionSwitch;
